export const GetVolume = (x: number, y: number, z: number) =>
  Math.abs(
    ((1.0 * x || 0) / 100) * ((1.0 * y || 0) / 100) * ((1.0 * z || 0) / 100)
  ).toFixed(3);
